import { Helmet } from 'react-helmet-async';

interface ServiceSchemaProps {
  name: string;
  description: string;
  url: string;
  provider?: string;
  areaServed?: string;
  serviceType?: string;
}

export const ServiceSchema = ({
  name,
  description,
  url,
  provider = "RSA Tech Group",
  areaServed = "Worldwide",
  serviceType
}: ServiceSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": name,
    "description": description,
    "url": url,
    "provider": {
      "@type": "Organization",
      "name": provider,
      "url": "https://rsatech.com"
    },
    "areaServed": areaServed,
    ...(serviceType && { "serviceType": serviceType })
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// Pre-configured service schemas
export const AITransformationSchema = () => (
  <ServiceSchema
    name="AI Transformation & Automation"
    description="Enterprise-wide AI implementation and process automation strategies. From initial assessment to full-scale implementation."
    url="https://rsatech.com/what-we-do/ai-transformation-automation"
    serviceType="AI Services"
  />
);

export const ManagedServicesSchema = () => (
  <ServiceSchema
    name="Managed Services & AIOps"
    description="24/7 infrastructure management with AI-driven operations and predictive maintenance."
    url="https://rsatech.com/what-we-do/managed-services-aiops"
    serviceType="Managed IT Services"
  />
);

export const CloudInfrastructureSchema = () => (
  <ServiceSchema
    name="Cloud Infrastructure"
    description="Cloud-native architectures, migration, and optimization services across all major cloud platforms."
    url="https://rsatech.com/what-we-do/cloud-infrastructure"
    serviceType="Cloud Services"
  />
);

export const CognitiveEnterpriseSchema = () => (
  <ServiceSchema
    name="Cognitive Enterprise Solutions"
    description="Strategic frameworks for building intelligent, adaptive organizations that leverage AI at every level."
    url="https://rsatech.com/what-we-do/cognitive-enterprise"
    serviceType="Enterprise Services"
  />
);

export const GenerativeAISchema = () => (
  <ServiceSchema
    name="Generative AI Solutions"
    description="Custom LLM implementations, fine-tuning, RAG systems, and enterprise AI applications."
    url="https://rsatech.com/what-we-do/generative-ai"
    serviceType="AI Development"
  />
);
